import { useSearchParams } from 'react-router-dom';

import { PlayUserType } from '@genially/p2p-lib';

import { PlayerClientProvider } from '../../../../../../../player/application/pages/PlayerGamePage/components/PlayerClientProvider/PlayerClientProvider';
import { PlayerGamePage } from '../../../../../../../player/application/pages/PlayerGamePage/PlayerGamePage';
import { PlayerUsernameSelectionPage } from '../../../../../../../player/application/pages/PlayerUsernameSelectionPage/PlayerUsernameSelectionPage';
import { CheckIsGeniallyCompatibleGuard } from '../../guards/CheckIsGeniallyCompatibleGuard';
import { CheckSessionIdGuard } from '../../guards/CheckSessionIdGuard';
import { TrackPageView } from '../../hocs/TrackPageView/TrackPageView';
import { PlayerConfigWizardLayout } from '../../layouts/PlayerConfigWizardLayout/PlayerConfigWizardLayout';

/**
 * Renders at the player "join" URL (used by invite links, QR codes and the
 * session finder). When the host previously bounced the player back here with
 * an `error` query param (username taken / session blocked), it falls back to
 * the legacy username-selection wizard. Otherwise it joins the session
 * directly, without asking for a name upfront.
 */
export const PlayerJoinRoute = () => {
  const [searchParams] = useSearchParams();

  const hasError = searchParams.has('error');

  if (hasError) {
    return (
      <PlayerConfigWizardLayout>
        <CheckSessionIdGuard>
          {({ geniallyId, sessionId }) => (
            <TrackPageView>
              <PlayerUsernameSelectionPage
                geniallyId={geniallyId}
                sessionId={sessionId}
              />
            </TrackPageView>
          )}
        </CheckSessionIdGuard>
      </PlayerConfigWizardLayout>
    );
  }

  return (
    <CheckSessionIdGuard>
      {({ geniallyId, sessionId }) => (
        <CheckIsGeniallyCompatibleGuard
          geniallyId={geniallyId}
          userType={PlayUserType.Player}
        >
          <PlayerClientProvider params={{ sessionId, geniallyId, username: undefined }}>
            <TrackPageView>
              <PlayerGamePage />
            </TrackPageView>
          </PlayerClientProvider>
        </CheckIsGeniallyCompatibleGuard>
      )}
    </CheckSessionIdGuard>
  );
};
